export default __webpack_public_path__ + "static/media/logo.b4289cf0.jpg";